<template>
  <div class="base-table">
    <!-- 搜索栏 -->
    <div v-if="showSearch" class="search-bar">
      <el-input
        v-model="searchQuery"
        placeholder="输入关键词搜索"
        clearable
        @clear="handleSearchClear"
        @input="handleSearch"
        style="width: 300px"
      >
      </el-input>
      <el-button
        icon="el-icon-search"
        size="small"
        style="border: 1px solid #ccc"
        @click="handleSearch"
      ></el-button>
      <slot name="search-bar-right"></slot>
    </div>

    <!-- 表格主体 -->
    <el-table
      ref="table"
      v-bind="$attrs"
      :header-cell-style="headerStyle"
      :data="tableData"
      :border="border"
      :stripe="stripe"
      :size="size"
      :height="height"
      :max-height="maxHeight"
      :highlight-current-row="highlightCurrentRow"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
      @sort-change="handleSortChange"
      v-loading="loading"
      :default-expand-all="defaultExpandAll"
      :tree-props="treeProps"
      :row-key="treeProps.id"
    >
      <!-- 选择列 -->
      <el-table-column
        v-if="showSelection"
        :selectable="ShowCheckSelectable ? checkSelectable : () => true"
        type="selection"
        width="45"
      />

      <!-- 序号列 -->
      <el-table-column
        v-if="showIndex"
        label="序号"
        type="index"
        width="50"
        align="center"
      ></el-table-column>

      <!-- 动态列 -->
      <template v-for="column in columns">
        <el-table-column
          :key="column.prop"
          v-bind="column"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :align="column.align || 'center'"
          :sortable="column.sortable || false"
          show-overflow-tooltip
          :fixed="column.fixed"
        >
          <template slot-scope="scope">
            <slot
              v-if="column.slotName"
              :name="column.slotName"
              :row="scope.row"
              :index="scope.$index"
            />
            <template v-else>
              {{ scope.row[column.prop] }}
            </template>
          </template>
        </el-table-column>
      </template>

      <!-- 操作列 -->
      <el-table-column
        v-if="showOperation"
        label="操作"
        align="center"
        :width="operationWidth"
      >
        <template slot-scope="scope">
          <slot name="operation" :row="scope.row" :index="scope.$index" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div v-if="showPagination" class="pagination">
      <el-pagination
        v-bind="paginationProps"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseTable",
  props: {
    // 表格数据
    data: {
      type: Array,
      default: () => [],
    },
    //加载
    loading: {
      type: Boolean,
      default: false,
    },
    // 列配置
    columns: {
      type: Array,
      default: () => [],
    },
    // 是否显示搜索框
    showSearch: {
      type: Boolean,
      default: false,
    },
    // 是否显示select禁用启动权限
    ShowCheckSelectable: {
      type: Boolean,
      default: false,
    },
    // 是否显示选择列
    showSelection: {
      type: Boolean,
      default: false,
    },
    // 是否显示序号列
    showIndex: {
      type: Boolean,
      default: true,
    },
    // 是否显示操作列
    showOperation: {
      type: Boolean,
      default: true,
    },
    // 树形结构配置
    treeProps: {
      type: Object,
      default: () => ({
        id: "id",
        children: "children",
        hasChildren: "hasChildren",
      }),
    },
    // 是否是树形结构
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    // 操作列宽度
    operationWidth: {
      type: [String, Number],
      default: "180",
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true,
    },
    // 分页配置
    paginationProps: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0,
        pagerCount: 10,
        layout: "total, sizes, prev, pager, next, jumper",
      }),
    },
    // 表格头部样式
    headerStyle: {
      type: Object,
      default: () => ({
        // backgroundColor: '#e3e3e3',
        // fontWeight: 'bold'
      }),
    },
    // 表格属性
    border: {
      type: Boolean,
      default: false,
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "medium",
    },
    height: {
      type: [String, Number],
      default: null,
    },
    maxHeight: {
      type: [String, Number],
      default: null,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: "",
      tableData: [],
      multipleSelection: [],
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        this.tableData = val;
      },
    },
  },
  beforeDestroy() {},
  methods: {
    checkSelectable(row, index) {
      // 根据条件返回true(可选)或false(不可选)
      return row.isFolder ? false : true; // 仅status为active的行可选
    },
    // 搜索
    handleSearch() {
      this.$emit("search", this.searchQuery);
    },
    // 清空搜索
    handleSearchClear() {
      this.searchQuery = "";
      this.$emit("search", "");
    },
    SearchClear() {
      this.searchQuery = "";
    },
    // 分页大小变化
    handleSizeChange(size) {
      this.$emit("size-change", size);
    },
    // 当前页变化
    handleCurrentChange(page) {
      this.$emit("current-change", page);
    },
    // 选择变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.$emit("selection-change", selection);
    },
    // 行点击
    handleRowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    // 排序变化
    handleSortChange({ column, prop, order }) {
      this.$emit("sort-change", { column, prop, order });
    },
    // 刷新表格
    refresh() {
      this.$emit("refresh");
    },
    // 获取选中行
    getSelection() {
      return this.multipleSelection;
    },
    // 清空选中
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    // 设置当前行
    setCurrentRow(row) {
      this.$refs.table.setCurrentRow(row);
    },
  },
};
</script>

<style lang="less" scoped>
.base-table {
  .search-bar {
    margin-bottom: 15px;
    display: flex;
    justify-content: flex-end;
  }

  .pagination {
    margin-top: 15px;
    display: flex;
    justify-content: center;
  }

  /deep/ .el-pagination__rightwrapper {
    margin-left: 10px;
  }

  ::v-deep .el-table {
    width: 100%;
    th {
      // background-color: #f5f7fa;
      // color: #606266;
      // font-weight: bold;
    }
  }

  .el-button--default {
    border: 1px solid #dcdfe6 !important;
  }
}
</style>
